const BUZON_SUGERENCIAS = (state, buzonsugerencias) => {
    state.buzonsugerencias = buzonsugerencias;
};

export default {
    BUZON_SUGERENCIAS,
};